import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Timetable } from '../../models/timetable';
import { FirebaseProvider } from '../firebase/firebase';

@Injectable()
export class TimetableProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {
  }

  /**
   * Recuperar horari segons ID.
   * 
   * @param id ID de l'horari.
   */
  getTimetable(id: string): Observable<Timetable> {
    return this.firebaseService.object(this.getBaseRoot() + id);
  }

  /**
   * Recuperar horari segons ID (només una vegada).
   * 
   * @param id ID de l'horari.
   */
  getTimetableOnce(id: string): Observable<Timetable> {
    return this.firebaseService.objectOnce(this.getBaseRoot() + id);
  }

  /**
   * Recuperar horaris.
   */
  getTimetables(): Observable<Timetable[]> {
    return this.firebaseService.list(this.getBaseRoot());
  }

  /**
   * Recuperar horaris segons les IDs proporcionades
   * 
   * @param timetablesIds IDs dels horaris.
   */
  getTimetablesByIdsOnce(timetablesIds): Observable<Timetable[]> {
      return this.firebaseService.listOnce(this.getBaseRoot())
        .map(timetables => timetables.filter(timetable => timetablesIds.indexOf(timetable.key) > -1));
  }

  /**
   * Eliminar horari segons ID.
   * 
   * @param timetableId ID de l'horari a eliminar.
   */
  remove(timetableId): Promise<void> {
    return this.firebaseService.remove(this.getBaseRoot(), timetableId)
  }
  
  /**
   * Guardar un horari.
   * 
   * @param timetable Horari a guardar.
   */
  save(timetable: Timetable): Promise<void> {
    if(timetable.key) {
      var key = timetable.key;
      delete timetable.key;
      return this.firebaseService.set(this.getBaseRoot(), key, timetable)
    }
      
    else return this.firebaseService.push(this.getBaseRoot(), timetable)
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Timetables + '/';
  }

}



// WEBPACK FOOTER //
// ./src/providers/timetable/timetable.ts